import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CUSTOM_STATUS';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    institutionId => ({institutionId}),
    behaviors => ({behaviors}),
);

export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
} = createAction(`${domain}/CREATE`, (institutionId, icon, color, title) => ({institutionId, icon, color, title}));

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE`,
    (statusConfigId, icon, color, title) => ({statusConfigId, icon, color, title}),
    statusConfigId => ({statusConfigId}),
    statusConfigId => ({statusConfigId}),
);

export const {
    action: enableHideFromChildActivity,
    success: enableHideFromChildActivitySuccess,
    failed: enableHideFromChildActivityFailed,
} = createAction(
    `${domain}/ENABLE_HIDE_CHILD_ACTIVITY`,
    institutionId => ({institutionId}),
    institutionId => ({institutionId}),
);

export const {
    action: disableHideFromChildActivity,
    success: disableHideFromChildActivitySuccess,
    failed: disableHideFromChildActivityFailed,
} = createAction(
    `${domain}/DISABLE_HIDE_CHILD_ACTIVITY`,
    institutionId => ({institutionId}),
    institutionId => ({institutionId}),
);

export const {action: edit} = createAction(`${domain}/EDIT`, id => ({id}));
